export default __webpack_public_path__ + "images/datagrid.b142bba14a45e85894248ee767ee27e3.svg";